import CopyrightStatement from './CopyrightStatement';

export default CopyrightStatement;
